import styled from '@emotion/styled';
import { TextField } from '@mui/material';

import { customPalette } from '../../../../styles/theme';

export const DialogWrapper = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);

  & > div {
    position: relative;
    background-color: ${customPalette.accent.white};
    border-radius: 20px;
    max-width: 450px;
    width: 100%;
    padding: 24px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    @media (max-width: 600px) {
      width: 100%;
      margin: 0;
      border-radius: 0;
      position: fixed;
      bottom: 0;
    }
  }
`;

export const DialogTitleWrapper = styled.div`
  padding: 0;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const DialogContentWrapper = styled.div`
  padding: 0 24px 24px 24px;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const ModalTitle = styled.h2`
  font-family: 'Nunito', sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: ${customPalette.grey.main};
  margin-bottom: 0;
  margin-top: 0;
`;

export const ModalSubtitle = styled.p`
  font-family: 'Nunito', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: ${customPalette.grey.main};
  margin: 24px 0;
`;

export const ModalInstructions = styled.p`
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: ${customPalette.grey.dark};
  margin-top: 0;
  margin-bottom: 0;
`;

export const ModalInstructionsThanks = styled.p`
  margin: 24px 0;
  font-size: 14px;
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const StyledCloseIcon = styled.div`
  cursor: pointer;
`;

export const ControlGroup = styled.div`
  margin-top: 0;
  margin-bottom: 24px;
`;

export const Label = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: ${customPalette.accent.main};
  margin-bottom: 0;
`;

export const FeedbackTextField = styled(TextField)`
  && {
    margin-top: 7px;

    textarea {
      font-family: 'Nunito', sans-serif;
      font-size: 14px;
      color: ${customPalette.accent.main} !important;
    }
  }
`;

export const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
`;

export const SuccessMessageDescriptionText = styled.div`
  padding: 32px 0;
`;
